import React from 'react';
import MobileProductField from './MobileProductField';

let nextItemId = 0;
export const emptyMobileCreateItem = () => ({
  key: `mobile-create-${++nextItemId}`,
  name: '',
  productCode: '',
  barcode: '',
  price: '0',
  quantity: '0',
  description: '',
  selected: true,
});

export default function MobileBulkCreateItem({ item, index, onChange, onRemove, disabled }) {
  const change = (key, value) => onChange({ ...item, [key]: value });
  return (
    <article className='mp-create-item'>
      <div className='mp-create-item-heading'>
        <label className='mp-check-row'>
          <input
            type='checkbox'
            checked={item.selected}
            disabled={disabled}
            onChange={event => change('selected', event.target.checked)}
          />
          <span>Товар {index + 1}</span>
        </label>
        <button
          type='button'
          className='btn btn-outline-danger'
          disabled={disabled}
          onClick={onRemove}
        >
          Прибрати
        </button>
      </div>
      <MobileProductField
        label='Назва'
        value={item.name}
        disabled={disabled}
        onChange={value => change('name', value)}
      />
      <MobileProductField
        label='Артикул'
        value={item.productCode}
        disabled={disabled}
        onChange={value => change('productCode', value)}
      />
      <div className='mp-field-grid'>
        <MobileProductField
          label='Ціна, грн'
          type='number'
          min='0'
          inputMode='numeric'
          value={item.price}
          disabled={disabled}
          onChange={value => change('price', value)}
        />
        <MobileProductField
          label='Кількість, шт.'
          type='number'
          min='0'
          inputMode='numeric'
          value={item.quantity}
          disabled={disabled}
          onChange={value => change('quantity', value)}
        />
      </div>
      <details>
        <summary>Штрихкод і опис</summary>
        <MobileProductField
          label='Штрихкод'
          value={item.barcode}
          disabled={disabled}
          onChange={value => change('barcode', value)}
        />
        <MobileProductField
          label='Опис'
          multiline
          rows='3'
          value={item.description}
          disabled={disabled}
          onChange={value => change('description', value)}
        />
      </details>
    </article>
  );
}
